export default __webpack_public_path__ + "static/media/ignite-1600419626-nHn4WXY79q.f6f971f3.jpg";